import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  offsetGridLines: true,
  drawTicks: true,
  barThickness: 35,
  layout: {
    // padding: {
    //   top: 20,
    //   right: 60,
    //   left: 60,
    //   bottom: 20,
    // },
  },
  plugins: {

    title: {
      display: true,
      // text: "Daily Volume",
      font: {
        size: 16,
      }

    },
    legend: {
      position: 'bottom' as const,
      labels: {
        boxWidth: 13,
        boxHeight: 13,
        generateLabels: function (chart: any) {
          return chart.data.datasets.map((dataset: any, i: any) => {
            return {
              text: dataset.label,
              fillStyle: dataset.backgroundColor,
              fontColor: dataset.backgroundColor,
              borderRadius: 3,
            };
          });
        }
      },
    },
  },
  responsive: true,
  scales: {
    // x: {
    //   stacked: true,
    // },
    // y: {
    //   stacked: true,
    // },
    x: {
      stacked: true,
      //display: false, // Hide x-axis line
      ticks: {
        color: '#396FAD', // Change y-axis label color
        font: {
          size: 11, // Change y-axis label font size
        },
      },
      grid: {
        display: false // Hide x-axis grid lines
      }
    },
    y: {
      stacked: true,
      ticks: {
        // stepSize:15,
        color: '#08425C', // Change y-axis label color
        font: {
          size: 10, // Change y-axis label font size
        },
        responsive: true 
      },
      grid: {
        display: false
      },

    }

  },
  legend: {
    display: false,
    position: "bottom",
    align: "start",
    labels: {
      usePointStyle: true,

    },

  },
};

export default function BarCharts(props: any) { 
  function getBackgroundColor(index: number, label: string) {
    // const colors = ['#A2E0EE', '#24608B', '#FFA63E', '#C9C9C9', '#CBD5EA', '#364771',];
    // return colors[index % colors.length];
    if (label === 'CLM') {
      return '#A2E0EE';
    } else if (label === 'Commercial DDA') {
      return '#24608B';
    } else if (label === 'Commercial Loan') {
      return '#FFA63E';
    }else if (label === 'Not Identified') {
      return '#C9C9C9';
    }
     else {
      // Default color
      return '#364771';
    }
  }
  const filteredDatasets = props.data.datasets.filter((dataset: any) => {   
    return dataset.data.some((value: any) => value !== 0);
  });

  const data = {
    labels: props.data.labels,   
    datasets: filteredDatasets.map((dataset: any, index: number) => ({      
      ...dataset,
      backgroundColor: getBackgroundColor(index, dataset.label), // Use dataset.label to determine the color
      borderColor: 'rgba(0,0,0,0.2)',
      borderWidth: 1
    }))
  };
  return (
    <Bar className='barchart' options={options} data={data} />
  )

}

